import './tabel.styles.css';

const Tabel = ({ data }) => {
    console.log(data);
    return (
        <>
            {/* <div className="mt-5">
                Example for: FCC=13 , FCODE=0 , State=0, InvState=0
            </div> */}

            <table>
                <thead>
                    <tr>
                        {/* <th>#</th> */}
                        <th>Event Name</th>
                        <th>Date and Time</th>
                        <th>Event Value</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => (
                        <tr key={item.id}>
                            {/* <td>{item.id}</td> */}
                            <td>{item.name}</td>
                            <td>{item.date}</td>
                            <td dangerouslySetInnerHTML={{ __html: item.bit_descriptions == '1' ? '' : '<ul><li>' + item.bit_descriptions.replace(/<br>/ig, '</li><li>') + '</li></ul>' }}>
                                {/* <ul>
                                    {item.bit_descriptions.replace(/<br>/ig, '</li><li>')}
                                </ul> */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default Tabel;